import { Constant } from '.'
import crypto from 'crypto-js'
import { addDays, format } from 'date-fns'

const saveUser = (data: any) => {
  return sessionStorage.setItem('supachar-user', JSON.stringify(data))
}

const removeUser = () => {
  return sessionStorage.removeItem('supachar-user')
}

const getUser = () => {
  const user = sessionStorage.getItem('supachar-user')
  return user ? JSON.parse(user) : null
}

const saveCallSession = (data: any) => {
  return sessionStorage.setItem('supachar-call', JSON.stringify(data))
}

const removeCallSession = () => {
  return sessionStorage.removeItem('supachar-call')
}

const getCallSession = () => {
  const call = sessionStorage.getItem('supachar-call')
  return !!call ? JSON.parse(call) : null
}

function isValidVideo(base64UrlOrUrl?: string): boolean {
  const allowedExtensions =
    Constant.videoValidationConfig.videoValidationExtensions

  if (base64UrlOrUrl?.startsWith('data:video/')) {
    const mimeMatch = base64UrlOrUrl.match(/data:video\/(\w+);base64,/)
    const mimeExtension = mimeMatch ? mimeMatch[1].toLowerCase() : ''
    return allowedExtensions.includes(mimeExtension)
  } else {
    const extension = base64UrlOrUrl?.split('.').pop()?.toLowerCase()
    return extension ? allowedExtensions.includes(extension) : false
  }
}

const sanitizeBase64 = (base64String: string) => {
  return base64String.replace(/[^A-Za-z0-9+/=]/g, '')
}

const decryptResponse = async (response: any) => {
  const [encodedData, signature] = response.split('.')
  const computedSignature = crypto
    .HmacSHA256(encodedData, process.env.RESPONSE_SECRET)
    .toString(crypto.enc.Hex)
  if (computedSignature !== signature) {
    throw new Error('Signature verification failed!')
  }
  const decodedData = decodeBase64Utf8(encodedData)
  const jsonObject = JSON.parse(decodedData)
  return jsonObject
}

const decodeBase64Utf8 = (str: string) => {
  const binary = atob(str)
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0))
  const decoder = new TextDecoder('utf-8')
  return decoder.decode(bytes)
}

const generateRandomPassword = (length = 7) => {
  const chars =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+~`|}{[]:;?><,./-='
  let password = ''
  for (let i = 0; i < length; i++) {
    password += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return password
}

const getStatusColor = (status: string) => {
  const items = {
    Pending: {
      text: 'danger',
      bg: 'danger50',
    },
    Invoice: {
      text: 'secondary',
      bg: 'secondary150',
    },
    'On Going': {
      text: 'secondary',
      bg: 'secondary150',
    },
    Paid: {
      text: 'success',
      bg: 'green50',
    },
    Unpaid: {
      text: 'danger',
      bg: 'danger50',
    },
    Confirmed: {
      text: 'text',
      bg: 'primary600',
    },
    Cancelled: {
      text: 'danger',
      bg: 'danger50',
    },
  }
  return items[status] || items['Other']
}

const getNext7Dates = (date = null) => {
  const dates = []
  const startDate = !!date ? new Date(date) : new Date()
  for (let i = 0; i < 7; i++) {
    const date = addDays(startDate, i)
    const formatted = format(date, 'yyyy-MM-dd')
    dates.push(formatted)
  }

  return dates
}

const getIdFromSlug = (slug: string) => {
  if (!!slug) {
    const splitSlug = slug.split('-')
    return parseInt(splitSlug.pop())
  }
}

const getTimeOfDay = () => {
  const hour = new Date().getHours()
  if (hour >= 5 && hour < 12) {
    return 'Morning'
  } else if (hour >= 12 && hour < 17) {
    return 'Afternoon'
  } else {
    return 'Evening'
  }
}

export default {
  saveUser,
  removeUser,
  getUser,
  saveCallSession,
  removeCallSession,
  getCallSession,
  isValidVideo,
  sanitizeBase64,
  decryptResponse,
  generateRandomPassword,
  getStatusColor,
  getNext7Dates,
  getIdFromSlug,
  getTimeOfDay,
}
